/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { OutlyingPointComponent } from './outlying-point.component';
import { OutlyingPointDataComponent } from './data/outlying-point-data.component';
import { OutlyingPointResolver } from './shared/outlying-point.resolver';
import { NgModule } from '@angular/core';

const outlyingPoinrRoutes: Routes = [
    {
        path: 'outlying-points',
        component: OutlyingPointComponent,
        data: { tab: 'Outlying-Points' },
        resolve: {
            tabData: OutlyingPointResolver
        },
        canDeactivate: [CanDeactivateViaEditGuardService],
        children: [
            {
                path: 'data',
                component: OutlyingPointDataComponent,
                data: { tab: 'Outlying-Points' },
                resolve: {
                    tabData: OutlyingPointResolver
                },
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: OutlyingPointDataComponent,
                data: { tab: 'Outlying-Points' },
                resolve: {
                    tabData: OutlyingPointResolver
                },
                // canDeactivate: [CanDeactivateViaEditGuardService]
            }]
    }
];


/**
 * @export
 * @class OutlyingRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(outlyingPoinrRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class OutlyingRoutingModule {

}
